import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {FormLayout, Select2} from 'shared/components';

const VacationPayoutForm = observer(({uiState}) => {
  const {typePolicy} = uiState;

  return (
    <FormLayout>
      <Select2
        label='time_off.policy.edit.Balance reset on'
        value={typePolicy.accrualStart}
        onChange={e => uiState.updateAccrualStart(e.target.value)}
      >
        <option value='policy_start_date'>{t('time_off.policy.edit.Policy start date')}</option>
        <option value='policy_holder_start_date'>{t("time_off.policy.edit.Employee's anniversary")}</option>
      </Select2>
    </FormLayout>
  );
});

export default VacationPayoutForm;
